const errorCodes = {
  AUTHENTICATION_FAILED: 100,
  ACCOUNT_NOT_FOUND: 101,
  USER_NOT_FOUND: 102,
  INVALID_TOKEN_FOR_USER: 103,
  ACCESS_NOT_ENABLED: 110,
  CREATE_SITE_FAILED: 200,
  UPDATE_SITE_FAILED: 201,
  PUBLISH_FAILED: 202,
  EXPORT_FAILED: 203,
  PREVIEW_FAILED: 204,
  DESIGN_FILE_NOT_CURRENT: 220,
  INVALID_PARAMETER: 300,
  ACTION_FAILED: 400,
  RESOURCE_NOT_FOUND: 404,
  DOMAIN_IN_USE: 500,
  NO_PRIMARY_DOMAIN: 503,
  SUBDOMAINS_ENABLED: 504,
  UNKNOWN_ERROR: 9000,
};

const errorText = {
  100: "Email And Password Do Not Match",
  101: "Account Not Found",
  102: "User Not Found",
  103: "Token Invalid For User",
  110: "Access Not Enabled",
  200: "Could Not Create",
  201: "Update Failed",
  202: "Publish Failed",
  203: "Export Failed",
  204: "Preview Failed",
  220: "Design File Not Current",
  300: "Invalid Parameter",
  400: "Action Failed",
  404: "Resource Not Found",
  500: "Domain In Use",
  503: "No Primary Domain",
  504: "Subdomains Enabled",
  9000: "Unknown Error",
};

export default errorCodes;

export const getErrorText = function (errorCode) {
  if (errorText.hasOwnProperty(errorCode)) {
    return errorText[errorCode];
  } else {
    throw new Error("Error code does not exist: " + errorCode);
  }
};
